import { WatchCondition } from './constants';
import typeHints from './typeHints';
import countries from './countries';

const attributes = {
  w_brand: {
    friendly: 'Brand',
    validations: {
      maxLength: 45,
    },
  },
  w_model: {
    friendly: 'Model',
    validations: {
      maxLength: 45,
    },
  },
  w_name: {
    friendly: 'Name',
    validations: {
      maxLength: 255,
    },
  },
  w_references: {
    friendly: 'Ref No.',
    validations: {
      maxLength: 255,
    },
  },
  w_movement: {
    friendly: 'Movement',
    validations: {
      maxLength: 45,
    },
  },
  w_caliber: {
    friendly: 'Caliber',
    validations: {
      maxLength: 45,
    },
  },
  w_case_material: {
    friendly: 'Case Material',
    validations: {
      maxLength: 45,
    },
  },
  w_band_material: {
    friendly: 'Band Material',
    validations: {
      maxLength: 45,
    },
  },
  w_glass_type: {
    friendly: 'Glass Type',
    validations: {
      maxLength: 45,
    },
  },
  w_dial_type: {
    friendly: 'Dial Type',
    validations: {
      maxLength: 45,
    },
  },
  w_diameter_mm: {
    friendly: 'Diameter MM',
    validations: {
      type: 'decimal',
      mustBePositive: true,
    },
  },
  w_thickness_mm: {
    friendly: 'Thickness MM',
    validations: {
      type: 'decimal',
      mustBePositive: true,
    },
  },
  w_power_reserve_h: {
    friendly: 'Power Reserve (h)',
    validations: {
      type: 'decimal',
      mustBePositive: true,
    },
  },
  w_water_resistance: {
    friendly: 'Water Resistance',
    validations: {
      maxLength: 45,
    },
  },
  w_dial_markers: {
    friendly: 'Dial Markers',
    validations: {
      maxLength: 45,
    },
  },
  w_calendar_type: {
    friendly: 'Calendar Type',
    validations: {
      maxLength: 45,
    },
  },
  w_band_type: {
    friendly: 'Band Type',
    validations: {
      maxLength: 45,
    },
  },
  w_case_inlays: {
    friendly: 'Case Inlays',
    validations: {
      maxLength: 45,
    },
  },
  w_dial_inlays: {
    friendly: 'Dial Inlays',
    validations: {
      maxLength: 45,
    },
  },
  w_dial_color: {
    friendly: 'Dial Color',
    validations: {
      maxLength: 45,
    },
  },
  w_clasp_type: {
    friendly: 'Clasp Type',
    validations: {
      maxLength: 45,
    },
  },
  w_year_produced: {
    friendly: 'Year Produced',
    validations: {
      type: 'integer',
      mustBePositive: true,
    },
  },
  w_condition: {
    friendly: 'Condition',
    validations: {
      type: 'enum',
      enumType: WatchCondition,
    },
  },
  w_limited_edition: {
    friendly: 'Limited Edition',
    validations: {
      maxLength: 45,
    },
  },
  w_warranty: {
    friendly: 'Warranty',
    validations: {
      maxLength: 45,
    },
  },
  w_serial_no: {
    friendly: 'Serial No.',
    validations: {
      maxLength: 45,
    },
  },
  w_case_no: {
    friendly: 'Case No.',
    validations: {
      maxLength: 45,
    },
  },
  w_clasp_no: {
    friendly: 'Clasp No.',
    validations: {
      maxLength: 45,
    },
  },
  w_purchase_condition: {
    friendly: 'Purchase Condition',
    validations: {
      type: 'enum',
      enumType: WatchCondition,
    },
  },
  w_msrp: {
    friendly: 'MSRP',
    validations: {
      type: 'decimal',
      mustBePositive: true,
    },
    typeHint: typeHints.Monetary,
  },
  w_country_of_origin: {
    friendly: 'Country Of Origin',
    validations: {
      type: 'enum',
      enumType: countries,
    },
  },
  w_style: {
    friendly: 'Style',
    validations: {
      maxLength: 45,
    },
  },
  w_lug_width: {
    friendly: 'Lug Width',
    validations: {
      maxLength: 45,
    },
  },
  w_bezel_type: {
    friendly: 'Bezel Type',
    validations: {
      maxLength: 45,
    },
  },
  w_complications: {
    friendly: 'Complications',
    validations: {
      maxLength: 45,
    },
  },
};

export default attributes;

export const WatchRequiredAttributes = [];

export const WatchItemSearchAttributes = ['w_brand', 'w_model', 'w_diameter_mm', 'w_case_material', 'w_dial_color'];

export const WatchDefaultSplitAttribute = 'w_brand';

export const WatchOverviewAttributes = ['title', 'w_year_produced', 'w_country_of_origin',  'w_condition', 'rarity', 'market_value', 'inventory_no', 'tags'];

export const WatchSpecificationAttributes = [
  'w_brand',
  'w_model',
  'w_references',
  'w_msrp',
  'w_movement',
  'w_caliber',
  'w_case_material',
  'w_bezel_type',
  'w_band_type',
  'w_band_material',
  'w_clasp_type',
  'w_dial_color',
  'w_dial_type',
  'w_dial_inlays',
  'w_dial_markers',
  'w_glass_type',
  'w_power_reserve_h',
  'w_water_resistance',
  'w_diameter_mm',
  'w_thickness_mm',
];

export const WatchPurchaseAttributes = [
  'purchase_date',
  'purchase_price',
  'w_purchase_condition',
  'purchase_contact',
  'purchase_notes',
];

export const WatchDetailAttributes = [
  'w_warranty',
  'accessories',
  'w_serial_no',
  'w_case_no',
  'w_clasp_no',
];

export const WatchDisplayAttributes = ['w_brand', 'w_model', 'w_name', 'w_case_material', 'w_diameter_mm', 'w_dial_color', 'w_references', 'tags'];

export const WatchSliderGalleryAttributes = {
  titleKey: 'w_model',
  subtitleKey: 'w_references',
};



// WEBPACK FOOTER //
// ./src/config/watchDataAttributes.js